module.exports = __webpack_public_path__ + "img/chakib.90b6b32e.jpg";